import styled from "styled-components";

export const MenuList = styled.ul`
    padding: 0.25rem 0;
    margin: 0;

    list-style: none;
`;
